var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeatureOneClickFilled = function SvgFeatureOneClickFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M12.457 13V8.5a1.5 1.5 0 0 0-3 0V16l-2.032-.678a1.652 1.652 0 0 0-1.58 2.835l4.055 3.38a2.01 2.01 0 0 0 1.28.462h4.51a2 2 0 0 0 1.986-1.752l.543-4.343a2 2 0 0 0-1.656-2.22l-4.106-.685M4.46 8a.5.5 0 0 1 .5-.5h1.5a.5.5 0 1 1 0 1h-1.5a.5.5 0 0 1-.5-.5M15.461 8a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1h-1.5a.5.5 0 0 1-.5-.5M16.444 3.548a.5.5 0 0 1-.242.664l-1.5.7a.5.5 0 0 1-.422-.906l1.5-.7a.5.5 0 0 1 .664.242M5.547 3.789a.5.5 0 0 1 .665-.242l1.5.7a.5.5 0 0 1-.423.906l-1.5-.7a.5.5 0 0 1-.242-.664M10.96 1.5a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-1 0V2a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })));
};
export default SvgFeatureOneClickFilled;